import { RootState } from '@admin/settings/store';

export const selectFirebaseUUID = (state: RootState): string | undefined =>
  state.user.firebaseUUID;
